import React from 'react';
import {formatDate, hasPermissionTo, PERSMISOS} from '../helpers';
import Strings from "../assets/strings";

import {
  Box,
  Button,
  Fab,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Theme,
  useMediaQuery,
  Zoom,
} from '@mui/material';

import makeStyles from "@mui/styles/makeStyles";
import {INota} from "../redux/types/IPrestamo";
import {Add, Close} from '@mui/icons-material';
import NotasPrestamo from "../views/prestamos/NotasPrestamo";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {eliminarNota} from "../redux/reducers/prestamosReducer";
import {useAppDispatch} from "../redux/hooks";


const useStyles = makeStyles((theme:Theme) => ({
  root: {
    // width: '100%',
    // overflowX: 'auto',
  },
  barTitle:{
    // padding: "6px 12px",
    // background: theme.palette.grey[200],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    '& > label':{
      marginRight: 0
    }
  },
}));


export default function ListNotas({ data = [], onTabClick,notasCount }:{notasCount?:number, data:INota[], onTabClick:(tab:number)=>void }) {
  const classes = useStyles();
  let navigate = useNavigate();
  let { preId } = useParams();
  let dispatch = useAppDispatch();
  const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));

  const {state:hState={},pathname} = useLocation();
  //----
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event:any, newPage:number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <div className={classes.barTitle}>
        <Box display={"flex"}>
          <Button onClick={()=>onTabClick(1)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>{Strings.pagos}</Button>
          <Button onClick={()=>onTabClick(2)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>{Strings.amortizacion}</Button>
          <Button onClick={()=>onTabClick(3)} variant="text" sx={{textTransform: "capitalize",height: "30px",background:"#eeeeee !important"}}>
            {Strings.notas} ({notasCount ??0})
          </Button>
        </Box>
      </div >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell/>
              <TableCell>{Strings.fecha}</TableCell>
              <TableCell>{Strings.fechaRecordatorio}</TableCell>
              <TableCell>{Strings.comentario}</TableCell>
              <TableCell>{Strings.creadoPor}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n =>
                <TableRow key={n.id}>
                  <TableCell className={"actionCell"}>
                    {hasPermissionTo(PERSMISOS.prestamosEliminarNotas) &&
                        <IconButton
                            onClick={()=>dispatch(eliminarNota({prestamoId:parseInt(preId!), id:n.id!}))}
                            size="large">
                          <Close className={"text-red"}/>
                        </IconButton>
                    }
                  </TableCell>
                  <TableCell>{formatDate(n.fechaCreacion)} {formatDate(n.fechaCreacion,"h:mm a")}</TableCell>
                  <TableCell>{formatDate(n.fechaRecordatorio)}</TableCell>
                  <TableCell>{n.nota}</TableCell>
                  <TableCell>{n.usuarioCreadoPor}</TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      {data.length > 10 &&
        <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            SelectProps={{
              inputProps: { 'aria-label': 'No. registros' },
              native: true,
            }}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
      }
      {hasPermissionTo(PERSMISOS.prestamosCrearNotas) &&
          <Zoom
              in={true}
              // timeout={transitionDuration}
              // style={{
              //   transitionDelay: `${value === index ? transitionDuration.exit : 0}ms`,
              // }}
              unmountOnExit
          >
            <Fab variant="extended" onClick={() => navigate(pathname, {state: {agregarNota: true}})}
                 sx={(theme)=>({
                   position: 'fixed',
                   right:smVewport?theme.spacing(1):undefined,
                   bottom: theme.spacing(2),
                   zIndex:2
                 })} size="small" color="primary" aria-label="agregar">

              <Add sx={{mr: 1}}/>
              {Strings.agregar} {Strings.nota}
            </Fab>
          </Zoom>
      }
      {!!hState?.agregarNota && <NotasPrestamo/>}

    </>
  );
}

